import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const PlayIcon = (p: IconProps) => <Icon {...p}><path d="m5 3 14 9-14 9V3z" /></Icon>
